const usd = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' });
const usdWhole = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
});

/**
 * Formats an amount as USD ("$1,234.50", or "$1,235" with `noDecimals`); numeric strings such as
 * "24.50" are formatted the same way. A missing or blank amount (an unset MSRP/MAPP, an order
 * without a total) renders as "~", and so do non-finite numbers rather than "$NaN". Other strings
 * (e.g. an already formatted "$24.50") pass through unchanged.
 */
export function formatPrice(amount: number | string | null | undefined, noDecimals?: boolean): string {
  if (typeof amount === 'string') {
    if (amount.trim() === '') return '~';
    const parsed = Number(amount);
    return Number.isNaN(parsed) ? amount : formatPrice(parsed, noDecimals);
  }
  if (amount == null || !Number.isFinite(amount)) return '~';
  return (noDecimals ? usdWhole : usd).format(amount);
}
